import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

export default function PublicRoute({ children }) {
  const { isAuthenticated, hasCompletedOnboarding } = useSelector(
    (state) => state.auth,
  );

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const price = params.get('package');

    if (price && !sessionStorage.getItem('from_upgrade_intent')) {
      sessionStorage.setItem('upgrade_intent', price);
      sessionStorage.setItem('from_upgrade_intent', 'true');
    }
  }, [location.search]);

  if (isAuthenticated && hasCompletedOnboarding) {
    const params = new URLSearchParams(location.search);
    const redirectTo = params.get('redirect') || '/app';

    return <Navigate to={redirectTo} replace />;
  }

  if (isAuthenticated && !hasCompletedOnboarding) {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}
